import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { Api } from '@api/api';
import { getProfileData, getProfileMedia } from '@api/functions';
import type { IgBusinessAccMediaDto, IgUserDto } from '@api/models';
import { onWindowLoad } from '../../helpers/on-window-load.function';

export enum InstagramMediaTypeEnum {
  Carousel = 'CAROUSEL_ALBUM',
  Video = 'VIDEO',
  Image = 'IMAGE'
}

@Component({
  selector: 'insta-widget',
  templateUrl: './insta-widget.component.html',
  styleUrls: ['./insta-widget.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstaWidgetComponent implements OnInit {
  private api = inject(Api);
  private destroyRef = inject(DestroyRef);

  readonly profile = signal<IgUserDto | null>(null);
  readonly media = signal<IgBusinessAccMediaDto[]>([]);
  readonly mediaType = InstagramMediaTypeEnum;

  ngOnInit(): void {
    onWindowLoad(() => {
      this.fetchProfileData();
      this.fetchMedia();
    });
  }

  private fetchProfileData(): void {
    this.api.invoke(getProfileData).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: response => {
        this.profile.set(response);
      }
    });
  }

  private fetchMedia(): void {
    this.api.invoke(getProfileMedia).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: response => {
        this.media.set(response.data);
      }
    });
  }

  setPostUrl(post: IgBusinessAccMediaDto): string {
    return post.media_type === this.mediaType.Video ? post.thumbnail_url : post.media_url;
  }
}
